import type { SVGProps } from "react"

type IconProps = SVGProps<SVGSVGElement>

function Icon({ children, ...props }: IconProps) {
  return (
    <svg
      viewBox="0 0 18 18"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {children}
    </svg>
  )
}

export function TranslateIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        strokeOpacity={0.5}
        d="M2.81299 4.36199H9.18699M5.99999 4.31299V2.81299M8.99999 10.688C5.95099 9.89799 4.38399 7.95999 3.93799 4.49999M2.99999 10.5C6.04799 9.73499 7.61499 7.85499 8.06299 4.49999M10.758 12.844H14.742M15.937 14.437L13.452 7.85699C13.207 7.20999 12.292 7.20999 12.048 7.85699L9.56299 14.437"
      />
    </Icon>
  )
}

export function VoiceMidIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        strokeOpacity={0.5}
        d="M5.81299 4.31299V13.688M2.81299 8.06299V9.93699M8.99999 7.31299V10.688M12.188 5.81299V12.188M15.188 8.06299V9.93699"
      />
    </Icon>
  )
}

export function SpeedHighIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        strokeOpacity={0.5}
        d="M4.68901 14.436C3.56059 13.5411 2.73862 12.3173 2.3371 10.9342C1.93558 9.55109 1.97443 8.07734 2.44824 6.71732C2.92205 5.35731 3.80735 4.17845 4.98134 3.34426C6.15534 2.51007 7.55983 2.06189 9.00001 2.06189C10.4402 2.06189 11.8447 2.51007 13.0187 3.34426C14.1927 4.17845 15.078 5.35731 15.5518 6.71732C16.0256 8.07734 16.0644 9.55109 15.6629 10.9342C15.2614 12.3173 14.4394 13.5411 13.311 14.436"
      />
      <path
        fill="currentColor"
        stroke="none"
        d="M7.85101 10.713C7.72093 10.5626 7.62205 10.3878 7.56014 10.1988C7.49823 10.0098 7.47451 9.81039 7.49038 9.61216C7.50624 9.41392 7.56136 9.22082 7.65254 9.04408C7.74372 8.86735 7.86914 8.7105 8.02149 8.58268C8.17384 8.45486 8.35009 8.35861 8.53998 8.29953C8.72987 8.24045 8.92962 8.21972 9.12759 8.23855C9.32557 8.25737 9.51783 8.31538 9.69318 8.40919C9.86853 8.503 10.0235 8.63075 10.149 8.78499C11.005 9.80499 11.524 11.601 11.754 12.556C11.7705 12.6179 11.7689 12.6833 11.7496 12.7443C11.7302 12.8054 11.6938 12.8597 11.6447 12.9009C11.5956 12.942 11.5357 12.9683 11.4722 12.9766C11.4087 12.985 11.3441 12.975 11.286 12.948C10.385 12.557 8.70601 11.733 7.85101 10.713Z"
      />
    </Icon>
  )
}

export function ShieldIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        strokeOpacity={0.5}
        strokeLinecap="square"
        d="M15.188 5.20601C15.188 4.89115 15.0889 4.58428 14.9047 4.32888C14.7206 4.07348 14.4607 3.88251 14.162 3.78301L9.71199 2.30001C9.24984 2.14585 8.75014 2.14585 8.28799 2.30001L3.83799 3.78301C3.53945 3.88268 3.27982 4.07373 3.09587 4.32911C2.91191 4.5845 2.81295 4.89127 2.81299 5.20601V8.93401C2.81299 12.664 5.99999 14.437 8.99999 16.056C12 14.437 15.188 12.664 15.188 8.93401V5.20601Z"
      />
    </Icon>
  )
}
